import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectHeadCount = (state) => state.headcount || initialState

const makeSelectHeadCount = () => createSelector(
  selectHeadCount,
  (state) => state
)

export {
  selectHeadCount,
  makeSelectHeadCount
}
